/* eslint-disable */
/* tslint:disable */

/** updatePoolProfileRadius
 * method: put
 * summary: Update a hublo pool profile
 */

import type {
  UpdatePoolProfileRadiusBodyDto,
  BadRequestResponseDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/bff-worker/profile/radius`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/profile/radius`

export type RequestBody = UpdatePoolProfileRadiusBodyDto

export type UpdatePoolProfileRadiusSuccess = number
export type UpdatePoolProfileRadiusError =
  | BadRequestResponseDto
  | ApiResponseDto
